import { render, staticRenderFns } from "./CrossObject.vue?vue&type=template&id=9d4a0a66&scoped=true&"
import script from "./CrossObject.vue?vue&type=script&lang=ts&"
export * from "./CrossObject.vue?vue&type=script&lang=ts&"
import style0 from "./CrossObject.vue?vue&type=style&index=0&id=9d4a0a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4a0a66",
  null
  
)

export default component.exports